import { io, type Socket } from "socket.io-client"

const INTRADAY_NAMESPACE = "/intraday"

// polling is a backup transport for when websocket is not available
const SOCKET_TRANSPORTS: ("websocket" | "polling")[] = ["websocket", "polling"]

const socketsByAccountId = new Map<string, Socket>()

export function getOrCreateIntradaySocket(accountId: string): Socket {
  const existing = getIntradaySocket(accountId)
  if (existing) {
    return existing
  }

  const socket = io(INTRADAY_NAMESPACE, {
    query: { account: accountId },
    transports: SOCKET_TRANSPORTS,
  })

  socketsByAccountId.set(accountId, socket)
  return socket
}

export function getIntradaySocket(accountId: string): Socket | undefined {
  return socketsByAccountId.get(accountId)
}

export function closeIntradaySocket(accountId: string): void {
  const socket = getIntradaySocket(accountId)
  socket?.disconnect()
  socketsByAccountId.delete(accountId)
}
